import { render, staticRenderFns } from "./ReportOrders.vue?vue&type=template&id=44ecf83d&scoped=true&"
import script from "./ReportOrders.vue?vue&type=script&lang=js&"
export * from "./ReportOrders.vue?vue&type=script&lang=js&"
import style0 from "./ReportOrders.vue?vue&type=style&index=0&id=44ecf83d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ecf83d",
  null
  
)

export default component.exports